import React, { useEffect, useState } from 'react'
import KlarnaMessagingSkeleton from './KlarnaMessagingSkeleton'
import * as Styled from './KlarnaMessaging.styles'

const KlarnaMessaging = ({ price, dcid }) => {
  const [isKlarnaScriptLoading, setKlarnaScriptLoading] = useState(true)

  const convertedPriceToPence = Math.round(price * 100)

  useEffect(() => {
    const script = document.createElement('script')

    script.async = true
    script.setAttribute('data-client-id', dcid)
    script.setAttribute('data-environment', 'production')
    script.src = 'https://js.klarna.com/web-sdk/v1/klarna.js'
    document.body.appendChild(script)
    setKlarnaScriptLoading(false)
  }, [])

  if (isKlarnaScriptLoading) {
    return (
      <Styled.Wrapper>
        <KlarnaMessagingSkeleton />
      </Styled.Wrapper>
    )
  }

  return (
    <Styled.Wrapper>
      <klarna-placement
        id='klarna-messaging-pdp'
        data-key='credit-promotion-badge'
        data-locale='en-GB'
        data-purchase-amount={convertedPriceToPence}
        data-message-preference='Klarna'
      />
    </Styled.Wrapper>
  )
}
export default KlarnaMessaging
